<div class="resp-box cursor" *ngIf="hasDimension()">
  <span class="icon-green se-icons">action_resize</span>
  <div class="indent-div">
    <div>
      <span>{{dimension.height}}<span class="indent-text">*</span><span class="indent-text">{{dimension.width}}</span></span>
    </div>
  </div>
</div>
